<template>
    <button v-if=props.downIcon v-bind:disabled="props.disabled" class="btn-scv-bgcolor" :id="props.id" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            style="padding: 0px 0px;">
        <div class="d-flex align-items-center">
            <div class="icon-font-deepblue ms-auto" style="margin-right: 2px; letter-spacing: normal">
            </div>
            <span>{{ props.label }}</span>
            <div class="icon-font-deepblue ms-auto" style="margin-right: 2px; letter-spacing: normal">
                <i :class="props.disabled?'disabled-icon icon-arrow2down':'icon-arrow2down'"></i>
            </div>
        </div>
    </button>
    <button v-else  v-bind:disabled="props.disabled" :class="designType === 0 ? 'btn-scv-bgcolor' : 'btn-scv-white-small'" :id="props.id" data-bs-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false" style="padding: 0px 0px;">
        {{ props.label }}
    </button>
</template>

<script setup lang="ts">
interface Props {
    label: string;
    id?: string;
    disabled?: boolean;
    downIcon?: boolean;
    designType?: number;// 0 or 1
}
const props = withDefaults(defineProps<Props>(), {
    id: "navbarDropdown",
    disabled: false,
    downIcon: true,
    designType: 0,
});
</script>

<style scoped>
.disabled-icon {
    color: #E1E1E6;
}
</style>
